export default "__VITE_ASSET__DjfQT8a1__"